import { createFileRoute, Outlet, useMatches } from "@tanstack/react-router";
import { useDrawerLayoutContext } from "../../-DrawerLayoutContext";
import { useQuery } from "@tanstack/react-query";
import { useMemo, useEffect } from "react";
import { checkPermissionsInLoader } from "@dmca/frontend/hooks";
import { PageHeader } from "@dmca/frontend/components/nav";

export const Route = createFileRoute("/_authed/_drawerLayout/admin/plant")({
  component: RouteComponent,
  loader: async ({ context }) => {
    await checkPermissionsInLoader("Admin::UpdatePlant", context);
    const { trpcQcProxy: trpc, qc } = context;
    qc.prefetchQuery(trpc.plant.getAll.queryOptions());
  },
  head: () => ({
    meta: [
      {
        title: "Manage Plants | DNA Dashboard",
      },
    ],
  }),
});

function RouteComponent() {
  const { trpcQcProxy: trpc } = Route.useRouteContext();
  const navigate = Route.useNavigate();
  const id = useMatches({
    select: (matches) => {
      const match = matches[matches.length - 1];
      if (match.id.includes("add-new")) {
        return "add-new";
      }
      return (match.params as any)?.id as string;
    },
  });
  const { data: plants, isLoading } = useQuery(
    trpc.plant.getAll.queryOptions()
  );
  const parsedPlants = useMemo(
    () => [
      { label: "Add New Plant", value: "add-new" },
      ...(plants
        ?.map((x) => ({
          label: x.name,
          value: x.id,
        }))
        .sort((x, y) => x.label.localeCompare(y.label)) ?? []),
    ],
    [plants]
  );
  const {
    selectedItem: [, setSelectedItem],
  } = useDrawerLayoutContext({
    listItems: parsedPlants,
    isLoading,
    onItemSelected: (item: { label: string; value: string }) => {
      navigate({
        to: "/admin/plant/$id",
        params: {
          id: item.value,
        },
      });
    },
  });

  useEffect(() => {
    const selected = parsedPlants.find((x) => x.value === id);
    setSelectedItem(selected);
  }, [id, parsedPlants, setSelectedItem]);
  return (
    <>
      <PageHeader>Manage Plants</PageHeader>
      <Outlet />
    </>
  );
}
